module.exports = __webpack_public_path__ + "static/media/slide-mobile (5).a2a0dce6.jpg";